import React, { useCallback } from 'react';
import {
  Box,
  TextField,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
  Collapse
} from '@mui/material';
import DebouncedTextField from '../../Utils/debounce';

export default function Riposo({ parameters, setParameters }) {

  const set = (key, value) =>
    setParameters(prev => ({ ...prev, [key]: value }));

  const setField = useCallback((key, value) => {
    setParameters(prev => ({ ...prev, [key]: value }));
  }, []);

  const toggleRadio = (key, newValue) =>
    set(key, parameters[key] === newValue ? '' : newValue);

  const p = parameters;

  return (
    <Box sx={{ width: '50ch', display: 'grid', gap: 2 }}>

      <Box sx={{ p: 3, mb: 2, border: '1px solid rgba(0,0,0,0.23)', borderRadius: 2, backgroundColor: '#f5f5f5', textAlign: 'center' }}>
        <Box component="h1" sx={{ m: 0, fontSize: '1.8rem', fontWeight: 'bold', color: '#1976d2' }}>
          Accertamento Infermieristico
        </Box>
        <Box component="p" sx={{ m: 0, mt: 1, fontSize: '1rem', color: 'text.secondary' }}>
          Riposo
        </Box>
      </Box>

      <FormControl sx={{ flexDirection: 'row', gap: 2, alignItems: 'center' }}>
        <FormLabel sx={{ minWidth: 200 }}>Alterazioni del sonno</FormLabel>
        <RadioGroup row value={p.alterazioniSonno ?? ''}>
          <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('alterazioniSonno', 'true')}  />} label="Sì" />
          <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('alterazioniSonno', 'false')} />} label="No" />
        </RadioGroup>
        <Collapse in={p.alterazioniSonno === 'true'}>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <FormControl>
              <FormLabel>Insonnia</FormLabel>
              <RadioGroup row value={p.insonnia ?? ''}>
                <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('insonnia', 'true')}  />} label="Sì" />
                <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('insonnia', 'false')} />} label="No" />
              </RadioGroup>
            </FormControl>
            <FormControl>
              <FormLabel>Risvegli notturni</FormLabel>
              <RadioGroup row value={p.risvegliNotturni ?? ''}>
                <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('risvegliNotturni', 'true')}  />} label="Sì" />
                <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('risvegliNotturni', 'false')} />} label="No" />
              </RadioGroup>
            </FormControl>
          </Box>
        </Collapse>
      </FormControl>

      <FormControl sx={{ flexDirection: 'row', gap: 2, alignItems: 'center' }}>
        <FormLabel sx={{ minWidth: 200 }}>Riposato al risveglio</FormLabel>
        <RadioGroup row value={p.riposato ?? ''}>
          <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('riposato', 'true')}  />} label="Sì" />
          <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('riposato', 'false')} />} label="No" />
        </RadioGroup>
      </FormControl>

      <FormControl sx={{ flexDirection: 'row', gap: 2, alignItems: 'center' }}>
        <FormLabel sx={{ minWidth: 200 }}>Ore di sonno (h/notte)</FormLabel>
        <DebouncedTextField
          size="small"
          type="number"
          value={p.oreSonno ?? ''}
          onChange={(val) => setField('oreSonno', val)}
          sx={{ width: 120 }}
        />
      </FormControl>

    </Box>
  );
}